import React, { Component } from 'react';
import About from '../UI/About';
import Projects from '../UI/Projects';
import Timeline from '../UI/Experience';
import Sidebar from '../UI/Sidebar';
import Skills from '../UI/Skills';
import Writing from '../UI/Writing';

class Layout extends Component {
  state = {
    projects: [
      {
        id: 1,
        title: 'CV ChatBot',
        stack: 'Landbot Platform',
        description:
          'A simple chatbot to showcase my CV. This is just one of the many chatbots i can make for businesses. These usually improve customer interaction.',
        imageURL: 'images/landboticon.png',
        projectURL: 'https://landbot.io/u/H-448232-SPBKDAVC05J5ET62/index.html'
      },
      {
        id: 2,
        title: 'Crane Cloud',
        stack: 'Flask, ReactJS, k8, Postgres',
        description:
          'Managed Deployment cloud platform. I am contributing to the Flask API and the React Front-end as a student software engineer intern.',
        imageURL: 'images/cranecloudicon.png',
        projectURL: 'http://staging.cranecloud.io/',
      },
      {
        id: 3,
        title: 'WIDs System',
        stack: 'Codeignitor, MySQL',
        description:
          'Weather Information and Dissemination System. I took part in building the backend codebase. Aimed at passing on weather information.',
        imageURL: 'images/widsICON.png',
        projectURL: 'http://wids.mak.ac.ug/wids/',
      },
      {
        id: 4,
        title: 'SlumData App',
        stack: 'ReactJs, Laravel, MySql',
        description:
          'A data collection app to measure proportion of urban population living in slums, informal settlements or inadequate housing. An open source project we built in a Build4SDG Challenge by Andela and Facebook',
        imageURL: 'images/slumDataicon.png',
        projectURL: 'https://github.com/BuildForSDG/Team-269-Frontend',
      },
      {
        id: 5,
        title: 'Covid19 ChatBot',
        stack: 'LandBot',
        description:
          'In a team of 3, we built a chatbot to help pass on information related to covid 19 in different native languages and show stats with ability for case reporting. Looking for support to further the idea',
        imageURL: 'images/cvidmyfticon.png',
        projectURL: 'https://covid19.mfeyti.com/',
      },
      {
        id: 6,
        title: 'MDA App',
        stack: 'R programming',
        description:
          'MDA-App is an application that is built in R to analyse the data set, features from apps on Google Play Store to determine which features affect download rate. This was a class project for 2nd yar recess term ',
        imageURL: 'images/Rdashboard.png',
        projectURL: 'https://github.com/MutegekiHenry/Mobile-Download-Analysis-Application',
      },

     
    ],
  };
  render() {
    return (
      <div id="colorlib-page">
        <div id="container-wrap">
          <Sidebar />
          <div id="colorlib-main">
            <About />
            <Projects projects={this.state.projects} />
            <Skills />
            <Timeline/>
            <Writing />
          </div>
        </div>
      </div>
    );
  }
}

export default Layout;
